import { useState, useRef } from "react";
import { 
  HiOutlineArrowRight, 
  HiOutlineArrowNarrowRight, 
  HiOutlineShieldCheck, 
  HiOutlineLightBulb, 
  HiOutlineUserGroup, 
  HiOutlineChartBar,
  HiOutlineGlobe,
  HiOutlineOfficeBuilding,
  HiOutlineSparkles,     // Added for Innovation
  HiOutlineHand,         // Added for Partnership and Collaboration
  HiOutlineHeart
} from "react-icons/hi";

import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import banner5 from "../assets/banner5.jpg";
import banner6 from "../assets/banner6.jpg";
import user from "../assets/user.png"; 
import peter from "../assets/peter.jpg"; 

const valuesData = [
  { 
    icon: <HiOutlineShieldCheck size={28} />, 
    title: "Customer Excellence", 
    desc: "Guests stay at the center of everything we do, with service designed to exceed expectations." 
  },
  { 
    icon: <HiOutlineLightBulb size={28} />, 
    title: "Professionalism", 
    desc: "Competent, reliable, and accountable hospitality and property management at every step." 
  },
  { 
    icon: <HiOutlineUserGroup size={28} />, 
    title: "Integrity", 
    desc: "Honesty, transparency, fairness, and ethical conduct with guests, partners, and regulators." 
  },
  { 
    icon: <HiOutlineChartBar size={28} />, 
    title: "Quality", 
    desc: "High standards for comfort, cleanliness, safety, and service delivery across all operations." 
  },
  { 
    icon: <HiOutlineSparkles size={28} />, 
    title: "Innovation", 
    desc: "Embracing creative solutions and modern technologies to continuously improve our hospitality services." 
  },
  { 
    icon: <HiOutlineHand size={28} />, 
    title: "Partnership and Collaboration", 
    desc: "Building strong, mutually beneficial relationships with property owners, local communities, and key stakeholders." 
  },
  { 
    icon: <HiOutlineHeart size={28} />, 
    title: "Authentic Hospitality", 
    desc: "Delivering warm, genuine, and welcoming experiences that make every guest feel truly at home." 
  }
];

const ecosystemData = [
  { title: "Property Leasing", desc: "Residential homes, villas, lodges, and serviced apartments.", img: banner1 },
  { title: "Property Management", desc: "Listing, bookings, housekeeping, maintenance, and co-hosting.", img: banner2 },
  { title: "Corporate Accommodation", desc: "Flexible stays for business teams, consultants, and officials.", img: banner3 },
  { title: "Travel Support", desc: "Transfers, travel guidance, local information, and concierge help.", img: banner4 },
  { title: "Tour Experiences", desc: "Curated city tours, cultural activities, and adventure packages.", img: banner5 },
  { title: "Partnerships", desc: "Work with owners, OTAs, corporate clients, and tourism stakeholders.", img: banner6 },
  { title: "Brand Growth", desc: "Scalable hospitality services designed for sustainable expansion.", img: banner1 },
  { title: "Authentic Hospitality", desc: "Warm, local, and memorable guest experiences in Tanzania.", img: banner2 }
];

const leadershipData = [
  { 
    name: "Mr. Peter Laizer", 
    role: "Managing Director", 
    img: peter,
    expertise: ["Strategic Leadership", "Business Development", "Stakeholder Engagement"],
    bio: "Provides strategic direction, corporate governance, partnership development, and overall business performance leadership."
  },
  { 
    names: "Rosemary Paul Laizer", 
    role: "Finance and Administration", 
    img: user,
    expertise: ["Administration", "Guest Relations", "Financial Management"],
    bio: "Supports daily coordination, guest care, bookkeeping, and operational follow-through across the company."
  },
  { 
    names: "Operations and Property Manager", 
    role: "Operations and Property Manager", 
    img: user,
    expertise: ["Property Maintenance", "Housekeeping", "Safety"],
    bio: "Oversees accommodation facilities, service providers, quality assurance, and guest-ready property standards."
  },
  { 
    names: "Marketing and Business Development Manager", 
    role: "Marketing and Business Manager", 
    img: user,
    expertise: ["Digital Marketing", "Corporate Clients", "Partnerships"],
    bio: "Leads branding, online visibility, market research, and strategic growth initiatives."
  },
  { 
    name: "Guest & Reservation Manager", 
    role: "Accommodation", 
    img: user,
    expertise: ["Digital Marketing", "Corporate Clients", "Partnerships"],
    bio: "Leads branding, online visibility, market research, and strategic growth initiatives."
  }
];

export default function AboutUsContent() {
  const [activeVM, setActiveVM] = useState("vision");
  const [activeLeader, setActiveLeader] = useState(0);
  const scrollRef = useRef(null);

  const scrollEcosystem = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 380;
      scrollRef.current.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@300;400;500;600;700;800;900&display=swap');
        
        :root {
          --sunflower-amber: #BC9132;
          --sunflower-light: #E8C547;
          --text-navy: #012243;
          --text-slate: #64748B;
          --bg-cream: #FAF7F2;
          --bg-white: #FFFFFF;
          --border-subtle: rgba(15, 23, 42, 0.08);
          --font-corporate: 'Libre Franklin', sans-serif;
        }

        .about-v2 {
          background: var(--bg-cream);
          font-family: var(--font-corporate);
          color: var(--text-navy);
          overflow-x: hidden;
        }

        /* --- SECTION 1: HERO INTRO --- */
        .about-hero {
          padding: 120px 48px 80px;
          max-width: 1320px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1.1fr 0.9fr;
          gap: 80px;
          align-items: center;
        }
        .about-hero-text .eyebrow {
          display: inline-flex; align-items: center; gap: 12px;
          font-size: 0.75rem; font-weight: 700; text-transform: uppercase;
          letter-spacing: 0.2em; color: var(--sunflower-amber); margin-bottom: 24px;
        }
        .about-hero-text .eyebrow::before { content: ''; width: 40px; height: 1px; background: var(--sunflower-amber); }
        .about-hero-text h1 {
          font-size: clamp(2.5rem, 5vw, 4rem); font-weight: 900; line-height: 1.05;
          letter-spacing: -0.04em; margin: 0 0 28px;
        }
        .about-hero-text h1 .italic { font-style: italic; font-weight: 300; color: var(--sunflower-amber); }
        .about-hero-text p {
          font-size: 1.1rem; line-height: 1.7; color: var(--text-slate); margin: 0 0 20px; max-width: 540px;
        }
        .about-hero-img {
          position: relative; border-radius: 24px; overflow: hidden; aspect-ratio: 4/5;
          box-shadow: 0 40px 80px -20px rgba(10, 15, 28, 0.2);
        }
        .about-hero-img img { width: 100%; height: 100%; object-fit: cover; }
        .about-hero-img .badge {
          position: absolute; bottom: 24px; left: 24px; right: 24px;
          padding: 20px; background: rgba(255,255,255,0.95); backdrop-filter: blur(10px);
          border-radius: 16px; display: flex; align-items: center; gap: 16px;
        }
        .about-hero-img .badge-icon {
          width: 48px; height: 48px; border-radius: 12px; background: var(--text-navy);
          color: var(--sunflower-amber); display: flex; align-items: center; justify-content: center;
        }
        .about-hero-img .badge-text strong { display: block; font-size: 1.1rem; font-weight: 800; }
        .about-hero-img .badge-text span { font-size: 0.8rem; color: var(--text-slate); }

        /* --- SECTION 2: VISION & MISSION SLIDER --- */
        .vm-section {
          padding: 80px 48px;
          max-width: 1320px;
          margin: 0 auto;
        }
        .vm-container {
          background: var(--text-navy);
          border-radius: 32px;
          overflow: hidden;
          display: grid;
          grid-template-columns: 1fr 1fr;
          min-height: 500px;
        }
        .vm-image {
          position: relative;
          overflow: hidden;
        }
        .vm-image img {
          width: 100%; height: 100%; object-fit: cover;
          transition: transform 1s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .vm-container:hover .vm-image img { transform: scale(1.05); }
        .vm-image::after {
          content: ''; position: absolute; inset: 0;
          background: linear-gradient(90deg, transparent 50%, var(--text-navy) 100%);
        }
        .vm-content {
          padding: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: #fff;
        }
        .vm-toggle {
          display: flex;
          gap: 8px;
          margin-bottom: 40px;
          background: rgba(255,255,255,0.05);
          padding: 6px;
          border-radius: 100px;
          width: fit-content;
        }
        .vm-toggle button {
          padding: 12px 28px;
          border: none;
          background: transparent;
          color: rgba(255,255,255,0.5);
          font-family: var(--font-corporate);
          font-size: 0.85rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          border-radius: 100px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .vm-toggle button.active {
          background: var(--sunflower-amber);
          color: var(--text-navy);
        }
        .vm-text h3 {
          font-size: 2.2rem; font-weight: 800; letter-spacing: -0.02em; margin: 0 0 20px; line-height: 1.2;
        }
        .vm-text p {
          font-size: 1.05rem; line-height: 1.8; color: rgba(255,255,255,0.75); margin: 0;
        }
        .vm-text ul {
          list-style: none; padding: 0; margin: 20px 0 0; display: grid; gap: 12px;
        }
        .vm-text ul li {
          display: flex; align-items: flex-start; gap: 12px;
          font-size: 0.95rem; color: rgba(255,255,255,0.8); line-height: 1.5;
        }
        .vm-text ul li::before {
          content: '◆'; color: var(--sunflower-amber); font-size: 0.6rem; margin-top: 6px; flex-shrink: 0;
        }

        /* --- SECTION 3: CORE VALUES --- */
        .values-section {
          padding: 80px 48px;
          max-width: 1320px;
          margin: 0 auto;
        }
        .section-title-block {
          text-align: center; margin-bottom: 60px;
        }
        .section-title-block h2 {
          font-size: clamp(2rem, 4vw, 3rem); font-weight: 900; letter-spacing: -0.03em; margin: 0 0 16px;
        }
        .section-title-block h2 .italic { font-style: italic; font-weight: 300; color: var(--sunflower-amber); }
        .section-title-block p { color: var(--text-slate); font-size: 1.05rem; max-width: 600px; margin: 0 auto; }
        
        .values-grid {
          display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px;
        }
        .value-card {
          background: var(--bg-white);
          border: 1px solid var(--border-subtle);
          border-radius: 20px;
          padding: 36px 28px;
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
          position: relative;
          overflow: hidden;
        }
        .value-card::before {
          content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 3px;
          background: var(--sunflower-amber); transform: scaleX(0); transform-origin: left;
          transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .value-card:hover::before { transform: scaleX(1); }
        .value-card:hover { transform: translateY(-8px); box-shadow: 0 20px 40px -15px rgba(10,15,28,0.1); border-color: transparent; }
        .value-icon {
          width: 56px; height: 56px; border-radius: 14px;
          background: rgba(188, 145, 50, 0.1); color: var(--sunflower-amber);
          display: flex; align-items: center; justify-content: center; margin-bottom: 24px;
        }
        .value-card h4 { font-size: 1.25rem; font-weight: 800; margin: 0 0 12px; letter-spacing: -0.01em; }
        .value-card p { font-size: 0.9rem; line-height: 1.6; color: var(--text-slate); margin: 0; }

        /* --- SECTION 4: ECOSYSTEM HORIZONTAL SLIDER --- */
        .eco-section {
          padding: 80px 0;
        }
        .eco-header {
          max-width: 1320px; margin: 0 auto; padding: 0 48px;
          display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 48px;
        }
        .eco-header h2 { font-size: clamp(2rem, 4vw, 3rem); font-weight: 900; letter-spacing: -0.03em; margin: 0; }
        .eco-header h2 .italic { font-style: italic; font-weight: 300; color: var(--sunflower-amber); }
        .eco-nav { display: flex; gap: 12px; }
        .eco-nav button {
          width: 52px; height: 52px; border-radius: 50%; border: 1px solid var(--border-subtle);
          background: var(--bg-white); color: var(--text-navy); cursor: pointer;
          display: flex; align-items: center; justify-content: center; transition: all 0.3s ease;
        }
        .eco-nav button:hover { background: var(--text-navy); color: #fff; border-color: var(--text-navy); }
        
        .eco-track {
          display: flex; gap: 24px; overflow-x: auto; scroll-snap-type: x mandatory;
          padding: 0 48px 20px; scrollbar-width: none; -ms-overflow-style: none;
        }
        .eco-track::-webkit-scrollbar { display: none; }
        .eco-card {
          flex: 0 0 340px; scroll-snap-align: start;
          border-radius: 20px; overflow: hidden; position: relative;
          aspect-ratio: 3/4; cursor: pointer;
          transition: transform 0.4s ease;
        }
        .eco-card:hover { transform: translateY(-8px); }
        .eco-card img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.8s ease; }
        .eco-card:hover img { transform: scale(1.1); }
        .eco-card-overlay {
          position: absolute; inset: 0;
          background: linear-gradient(180deg, transparent 40%, rgba(10,15,28,0.9) 100%);
          display: flex; flex-direction: column; justify-content: flex-end; padding: 32px;
        }
        .eco-card-overlay h4 { color: #fff; font-size: 1.4rem; font-weight: 800; margin: 0 0 8px; }
        .eco-card-overlay p { color: rgba(255,255,255,0.7); font-size: 0.9rem; margin: 0; line-height: 1.5; }

        /* --- SECTION 5: LEADERSHIP WITH NO-OVERFLOW FIXES --- */
        .leadership-section {
          padding: 80px 48px 100px;
          max-width: 1320px;
          margin: 0 auto;
        }
        .leadership-grid {
          display: grid;
          grid-template-columns: 420px 1fr;
          gap: 48px;
          background: var(--bg-white);
          border-radius: 32px;
          padding: 40px;
          border: 1px solid var(--border-subtle);
          box-shadow: 0 30px 60px -25px rgba(10, 15, 28, 0.06);
        }
        .leader-sidebar-layout {
          display: flex;
          flex-direction: column;
          gap: 32px;
          border-right: 1px solid var(--border-subtle);
          padding-right: 32px;
          min-width: 0; /* Prevents layout distortion */
        }
        .leader-spotlight {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          aspect-ratio: 1 / 1;
          background: var(--bg-cream);
          box-shadow: 0 16px 32px -10px rgba(10, 15, 28, 0.08);
        }
        .leader-spotlight img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .leader-spotlight:hover img {
          transform: scale(1.04);
        }
        .leader-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .leader-item {
          display: grid;
          grid-template-columns: auto 1fr;
          align-items: center;
          gap: 16px;
          padding: 12px 16px;
          border-radius: 14px;
          cursor: pointer;
          transition: all 0.25s ease;
          border: 1px solid transparent;
          background: transparent;
          min-width: 0;
        }
        .leader-item:hover {
          background: var(--bg-cream);
        }
        .leader-item.active {
          background: var(--text-navy);
          border-color: var(--text-navy);
        }
        .leader-item img {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid transparent;
          transition: border-color 0.25s ease;
        }
        .leader-item.active img {
          border-color: var(--sunflower-amber);
        }
        .leader-item-info {
          min-width: 0; /* Standard flex/grid cell fix for inner text clamping */
        }
        .leader-item-info h5 {
          font-size: 0.95rem;
          font-weight: 700;
          margin: 0 0 2px;
          color: var(--text-navy);
          transition: color 0.25s ease;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .leader-item-info span {
          display: block;
          font-size: 0.75rem;
          color: var(--text-slate);
          font-weight: 500;
          transition: color 0.25s ease;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .leader-item.active .leader-item-info h5 {
          color: #ffffff;
        }
        .leader-item.active .leader-item-info span {
          color: var(--sunflower-light);
        }
        .leader-details {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 16px 0;
          min-width: 0;
        }
        .leader-details h4 {
          font-size: 0.75rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          color: var(--sunflower-amber);
          margin: 0 0 16px;
        }
        .leader-details h2 {
          font-size: 2.2rem;
          font-weight: 900;
          letter-spacing: -0.02em;
          margin: 0 0 6px;
          line-height: 1.15;
        }
        .leader-details .role {
          font-size: 1.1rem;
          color: var(--text-slate);
          margin: 0 0 28px;
          font-weight: 600;
        }
        .leader-details p.bio {
          font-size: 1rem;
          line-height: 1.75;
          color: var(--text-navy);
          opacity: 0.85;
          margin: 0 0 32px;
        }
        .leader-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }
        .leader-tags span {
          padding: 8px 16px;
          background: var(--bg-cream);
          border-radius: 100px;
          font-size: 0.75rem;
          font-weight: 600;
          color: var(--text-navy);
          border: 1px solid var(--border-subtle);
        }

        @media (max-width: 992px) {
          .leadership-grid {
            grid-template-columns: 1fr;
            padding: 24px;
            gap: 32px;
          }
          .leader-sidebar-layout {
            border-right: none;
            padding-right: 0;
            gap: 24px;
          }
          .leader-spotlight {
            max-width: 320px;
            margin: 0 auto;
          }
          .leader-list {
            flex-direction: row;
            overflow-x: auto;
            padding: 4px 4px 12px;
            scroll-snap-type: x mandatory;
            gap: 12px;
            /* Make track smooth and visible without system scrollbars */
            scrollbar-width: none;
            -ms-overflow-style: none;
          }
          .leader-list::-webkit-scrollbar {
            display: none;
          }
          .leader-item {
            flex: 0 0 220px; /* Locked explicit width constraints */
            width: 220px;
            scroll-snap-align: start;
            background: var(--bg-cream);
            border: 1px solid var(--border-subtle);
          }
          .leader-item.active {
            background: var(--text-navy);
            border-color: var(--text-navy);
          }
          .leader-details {
            padding: 8px 0;
          }
          .leader-details h2 {
            font-size: 1.8rem;
          }
          .leader-details .role {
            margin-bottom: 20px;
          }
        }

        /* --- SECTION 6: GOVERNANCE & PARTNERS --- */
        .governance-section {
          padding: 0 48px 120px;
          max-width: 1320px;
          margin: 0 auto;
        }
        .gov-grid {
          display: grid; 
        }
        .gov-block {
        width:100%;
          background: var(--bg-white); border: 1px solid var(--border-subtle);
          border-radius: 24px; padding: 40px;
        }
        .gov-block h3 {
          font-size: 1.5rem; font-weight: 800; margin: 0 0 32px; letter-spacing: -0.01em;
          display: flex; align-items: center; gap: 12px;
        }
        .gov-block h3 .icon {
          width: 40px; height: 40px; border-radius: 10px; background: rgba(201,162,39,0.1);
          color: var(--sunflower-amber); display: flex; align-items: center; justify-content: center;
        }
        .gov-hierarchy { display: flex; flex-direction: column; gap: 16px; }
        .gov-node {
          padding: 20px; background: var(--bg-cream); border-radius: 12px;
          text-align: center; font-weight: 700; font-size: 0.95rem;
          border-left: 4px solid var(--sunflower-amber);
          transition: all 0.3s ease;
        }
        .gov-node:hover { transform: translateX(8px); background: #fff; box-shadow: 0 10px 20px -10px rgba(0,0,0,0.05); }
        .gov-connector { width: 2px; height: 20px; background: var(--border-subtle); margin: 0 auto; }
        
        .partners-list { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .partner-item {
          padding: 20px; background: var(--bg-cream); border-radius: 12px;
          font-size: 0.9rem; font-weight: 600; color: var(--text-navy);
          display: flex; align-items: center; gap: 12px; transition: all 0.3s ease;
        }
        .partner-item:hover { background: var(--text-navy); color: #fff; transform: translateY(-4px); }
        .partner-item .dot { width: 8px; height: 8px; border-radius: 50%; background: var(--sunflower-amber); flex-shrink: 0; }

        /* --- GLOBAL RESPONSIVE --- */
        @media (max-width: 1100px) {
          .about-hero { grid-template-columns: 1fr; gap: 48px; padding: 80px 32px 60px; }
          .about-hero-img { max-width: 500px; margin: 0 auto; }
          .vm-section, .values-section, .governance-section { padding-left: 32px; padding-right: 32px; }
          .vm-container { grid-template-columns: 1fr; }
          .vm-image { height: 300px; }
          .vm-image::after { background: linear-gradient(180deg, transparent 50%, var(--text-navy) 100%); }
          .values-grid { grid-template-columns: repeat(2, 1fr); }
          .gov-grid { grid-template-columns: 1fr; }
          .eco-header { padding: 0 32px; }
          .eco-track { padding: 0 32px 20px; }
        }

        @media (max-width: 768px) {
          .about-hero { padding: 60px 20px 40px; }
          .vm-section, .values-section, .leadership-section, .governance-section { padding-left: 20px; padding-right: 20px; }
          .vm-content { padding: 40px 24px; }
          .values-grid { grid-template-columns: 1fr; }
          .eco-header { flex-direction: column; align-items: flex-start; gap: 24px; }
          .eco-card { flex: 0 0 280px; }
          .partners-list { grid-template-columns: 1fr; }
          .eco-track { padding: 0 20px 20px; }
          .eco-header { padding: 0 20px; }
        }
      `}</style>

      <div className="about-v2">
        {/* 1. HERO INTRO */}
        <section className="about-hero">
          <div className="about-hero-text">
            <div className="eyebrow">About Mirabel Suites</div>
            <h1>
              Hospitality and property management built on <span className="italic">authentic</span> service.
            </h1>
            <p>
              Mirabel Suites is a privately owned Limited Liability Company under Tanzanian law, created to operate short-term accommodation and property management services.
            </p>
            <p>
              We own, lease, develop, manage, and maintain apartments, villas, houses, lodges, guesthouses, serviced apartments, and holiday homes.
            </p>
          </div>
          <div className="about-hero-img">
            <img src={banner3} alt="Mirabel Suites hospitality" />
            <div className="badge">
              <div className="badge-icon"><HiOutlineGlobe size={24} /></div>
              <div className="badge-text">
                <strong>National Reach</strong>
                <span>Headquartered in Arusha, Tanzania</span>
              </div>
            </div>
          </div>
        </section>

        {/* 2. VISION & MISSION SLIDER */}
        <section className="vm-section">
          <div className="vm-container">
            <div className="vm-image">
              <img src={activeVM === "vision" ? banner1 : banner2} alt="Vision and Mission" />
            </div>
            <div className="vm-content">
              <div className="vm-toggle">
                <button className={activeVM === "vision" ? "active" : ""} onClick={() => setActiveVM("vision")}>Our Vision</button>
                <button className={activeVM === "mission" ? "active" : ""} onClick={() => setActiveVM("mission")}>Our Mission</button>
              </div>
              <div className="vm-text">
                {activeVM === "vision" ? (
                  <>
                    <h3>To become Tanzania's leading hospitality and travel services provider.</h3>
                    <p>We aim to offer exceptional accommodation experiences, authentic local hospitality, and innovative tourism solutions that connect travelers to the best of Tanzania.</p>
                  </>
                ) : (
                  <>
                    <h3>High-quality, professionally managed service.</h3>
                    <p>We provide comfortable accommodation and travel services through personalized customer care, operational excellence, and strategic partnerships.</p>
                    <ul>
                      <li>Provide short-term and medium-term accommodation</li>
                      <li>Build a diversified hospitality property portfolio</li>
                      <li>Deliver exceptional guest experiences and support</li>
                      <li>Expand into travel and tourism-related services</li>
                    </ul>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* 3. CORE VALUES */}
        <section className="values-section">
          <div className="section-title-block">
            <h2>Guided by <span className="italic">core</span> values.</h2>
            <p>These principles shape how we serve guests, property owners, partners, and the wider community.</p>
          </div>
          <div className="values-grid">
            {valuesData.map((val, i) => (
              <div key={i} className="value-card">
                <div className="value-icon">{val.icon}</div>
                <h4>{val.title}</h4>
                <p>{val.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* 4. ECOSYSTEM HORIZONTAL SLIDER */}
        <section className="eco-section">
          <div className="eco-header">
            <h2>Our <span className="italic">core</span> Services.</h2>
            <div className="eco-nav">
              <button onClick={() => scrollEcosystem('left')} aria-label="Scroll left"><HiOutlineArrowRight style={{transform: 'rotate(180deg)'}} size={20} /></button>
              <button onClick={() => scrollEcosystem('right')} aria-label="Scroll right"><HiOutlineArrowRight size={20} /></button>
            </div>
          </div>
          <div className="eco-track" ref={scrollRef}>
            {ecosystemData.map((eco, i) => (
              <div key={i} className="eco-card">
                <img src={eco.img} alt={eco.title} />
                <div className="eco-card-overlay">
                  <h4>{eco.title}</h4>
                  <p>{eco.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* 5. LEADERSHIP SPOTLIGHT */}
        <section className="leadership-section">
          <div className="section-title-block">
            <h2>Management <span className="italic">team</span>.</h2>
            <p>A dedicated team responsible for strategic direction, guest satisfaction, operations, and business growth.</p>
          </div>
          
          <div className="leadership-grid">
            <div className="leader-sidebar-layout">
              <div className="leader-spotlight">
                <img src={leadershipData[activeLeader].img} alt={leadershipData[activeLeader].name} />
              </div>
              
              <div className="leader-list">
                {leadershipData.map((leader, i) => (
                  <div 
                    key={i} 
                    className={`leader-item ${activeLeader === i ? 'active' : ''}`}
                    onClick={() => setActiveLeader(i)}
                  >
                    <img src={leader.img} alt={leader.name} />
                    <div className="leader-item-info">
                      <h5>{leader.name}</h5>
                      <span>{leader.role}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="leader-details">
              <h4>Executive Profile</h4>
              <h2>{leadershipData[activeLeader].name}</h2>
              <p className="role">{leadershipData[activeLeader].role}</p>
              <p className="bio">{leadershipData[activeLeader].bio}</p>
              <div className="leader-tags">
                {leadershipData[activeLeader].expertise.map((exp, i) => (
                  <span key={i}>{exp}</span>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 6. GOVERNANCE & PARTNERSHIPS */}
        <section className="governance-section">
          <div className="gov-grid">
            <div className="gov-block">
              <h3><span className="icon"><HiOutlineUserGroup size={20} /></span> Core Partners</h3>
              <div className="partners-list">
                <div className="partner-item"><span className="dot" /> Property owners and real estate developers</div>
                <div className="partner-item"><span className="dot" /> Airbnb, Booking.com, Expedia, and OTAs</div>
                <div className="partner-item"><span className="dot" /> Tourism operators and transport providers</div>
                <div className="partner-item"><span className="dot" /> Financial institutions and investment partners</div>
                <div className="partner-item"><span className="dot" /> Corporate organizations and government clients</div>
                <div className="partner-item"><span className="dot" /> Marketing agencies and digital platforms</div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
